export * from "./components/rich-text.component";
export * from "./rich-text-module";